import findTopArtist from "../core/graphql/queries/findTopArtist"
import topSongsQuery from "../core/graphql/queries/findTop5Artist"
import { useQuery } from '@apollo/client';
import { makeStyles, Theme } from '@material-ui/core';
import { useHistory } from "react-router-dom"
import { useMemo } from "react"
import Avatar from "../pictures/dummyAvatar.svg"

/** Backend findTopArtist often mirrors chart types; allTime may need `all`. */
function mapFindTopArtistType(period: string): string {
  if (period === 'today') return 'week'
  if (period === 'allTime') return 'all'
  return period
}

function artistsFromTopSongs(rows: any[]): { _id: string; image?: string; artistName: string }[] {
  const byId = new Map<string, { _id: string; image?: string; artistName: string }>()
  for (const row of rows || []) {
    const a = row?.primaryArtist
    if (!a?._id) continue
    if (byId.has(a._id)) continue
    byId.set(a._id, {
      _id: a._id,
      image: a.image,
      artistName: a.displayName || row?.name || 'Artist',
    })
  }
  return Array.from(byId.values()).slice(0, 5)
}

export const TopArtist = ({ type }: { type: string }) => {
  const useStyles = makeStyles<Theme>(() => ({
    imageContainer: {
      width: '100px',
      height: '100px',
      borderRadius: '50%',
    },
    list: {
      display: 'flex',
      gap: "0.5rem",
    },
    text: {
      fontSize: '14px',
      wordBreak: "break-word",
    },
  }))

  const history = useHistory()
  const classes = useStyles()

  const apiType = mapFindTopArtistType(type)

  const { data: rankedData, loading: rankedLoading } = useQuery<any>(findTopArtist, {
    variables: { type: apiType },
    errorPolicy: 'all',
  })

  const rankedList = (rankedData?.findTopArtist || []).filter((a: any) => a && a._id)

  const songPeriod = type === 'today' ? 'week' : type

  const { data: songData } = useQuery<any>(topSongsQuery, {
    variables: { type: songPeriod },
    skip: rankedLoading || rankedList.length > 0,
    errorPolicy: 'all',
  })

  const artists = useMemo(() => {
    if (rankedList.length > 0) {
      return rankedList.map((a: any) => ({
        _id: a._id,
        image: a.image,
        artistName: a.artistName || 'Artist',
      }))
    }
    return artistsFromTopSongs(songData?.findTopSongAlbumArtist || [])
  }, [rankedList, songData])

  const artistsWithPlaceholders = [...artists, ...Array(Math.max(0, 5 - artists.length)).fill(null)]

  return (
    <div className={classes.list}>
      {artistsWithPlaceholders.map((artist: any, index: number) => (
        <div
          key={artist?._id || `placeholder-${index}`}
          style={{ width: '120px', textAlign: 'center', cursor: artist ? 'pointer' : 'default' }}
          onClick={() => artist?._id && history.push(`/artist/${artist._id}`)}
        >
          <img
            src={artist?.image ? artist.image : artist ? Avatar : '/starFarm.png'}
            alt=""
            className={classes.imageContainer}
          />
          <h3 className={classes.text}>
            {artist?.artistName || 'No Activity'}
          </h3>
        </div>
      ))}
    </div>
  )
}
